import { type JSX } from 'react/jsx-runtime';

export const StudioCardIllustrationDark = (): JSX.Element => (
	<svg
		height="128"
		width="100%"
		fill="none"
		preserveAspectRatio="xMinYMin slice"
		role="presentation"
		viewBox="0 0 335 128"
		xmlns="http://www.w3.org/2000/svg"
	>
		<g clipPath="url(#clip0_8794_200494)">
			<path fill="#2B2C2F" d="M0 8a8 8 0 0 1 8-8h319a8 8 0 0 1 8 8v120H0V8Z" />
			<rect width={226} height={142.478} x={55} y={13} fill="#242528" rx={9.826} />
			<rect width={99.489} height={62.641} x={171.686} y={22.826} fill="#1F1F21" rx={6} />
			<rect
				width={98.489}
				height={61.641}
				x={172.186}
				y={23.326}
				stroke="#E3E4F2"
				strokeOpacity={0.12}
				rx={5.5}
			/>
			<rect width={16} height={16} x={180} y={32} fill="#4B4D51" rx={4} />
			<path
				fill="#A9ABAF"
				fillRule="evenodd"
				d="M189.585 34.734a.5.5 0 0 1 .23.565l-1.158 4.2h2.843a.5.5 0 0 1 .354.854l-4.834 4.833a.5.5 0 0 1-.835-.486l1.158-4.2H184.5a.5.5 0 0 1-.354-.854l4.834-4.834a.5.5 0 0 1 .605-.078Zm-1.966 4.765.729-2.64-2.641 2.64h1.912Zm.762 1-.729 2.64 2.641-2.64h-1.912Z"
				clipRule="evenodd"
			/>
			<path fill="#E5E9F6" fillOpacity={0.25} d="M201 36h32v6h-32z" opacity={0.2} />
			<rect width={98.587} height={59.034} x={171.686} y={92.836} fill="#1F1F21" rx={6} />
			<rect
				width={97.587}
				height={58.034}
				x={172.186}
				y={93.336}
				stroke="#E3E4F2"
				strokeOpacity={0.12}
				rx={5.5}
			/>
			<rect width={16} height={16} x={180} y={102} fill="#4B4D51" rx={4} />
			<path
				fill="#A9ABAF"
				fillRule="evenodd"
				d="M183.999 105.999c0-.736.597-1.333 1.333-1.333h5.333c.737 0 1.334.597 1.334 1.333v8.334h.666v1h-9.333v-1h.667v-8.334Zm1 8.334h1.333v-2.5a.5.5 0 0 1 .5-.5h2.333a.5.5 0 0 1 .5.5v2.5h1.334v-8.334a.334.334 0 0 0-.334-.333h-5.333a.333.333 0 0 0-.333.333v8.334Zm3.666 0v-2h-1.333v2h1.333Zm-1.333-6.667h-1.333v-1h1.333v1Zm2.667 0h-1.334v-1h1.334v1Zm-4 1h1.333v1h-1.333v-1Zm2.666 0h1.334v1h-1.334v-1Z"
				clipRule="evenodd"
			/>
			<path fill="#E5E9F6" fillOpacity={0.25} d="M201 106h42v6h-42z" opacity={0.2} />
			<rect width={98.587} height={59.034} x={64.826} y={92.836} fill="#1F1F21" rx={6} />
			<rect
				width={97.587}
				height={58.034}
				x={65.326}
				y={93.336}
				stroke="#E3E4F2"
				strokeOpacity={0.12}
				rx={5.5}
			/>
			<path
				fill="#CECFD2"
				fillRule="evenodd"
				d="M81.075 103.116a1.843 1.843 0 0 1 1.895 0l4.606 2.764c.555.333.895.932.895 1.579v5.145c0 .647-.34 1.247-.895 1.58l-4.605 2.763c-.584.35-1.313.35-1.896 0l-4.606-2.763a1.843 1.843 0 0 1-.895-1.58v-5.145c0-.647.34-1.246.895-1.579l4.606-2.764Zm1.185 1.185a.459.459 0 0 0-.474 0l-4.606 2.764a.46.46 0 0 0-.224.394v5.145a.46.46 0 0 0 .224.395l1.012.607a3.915 3.915 0 1 1 7.662 0l1.011-.607a.46.46 0 0 0 .224-.395v-5.145a.46.46 0 0 0-.224-.394l-4.605-2.764Zm-.237 5.961a2.533 2.533 0 1 0 0 5.066 2.533 2.533 0 0 0 0-5.066Z"
				clipRule="evenodd"
			/>
			<rect width={16} height={16} x={73} y={102} fill="#4B4D51" rx={4} />
			<path
				fill="#A9ABAF"
				fillRule="evenodd"
				d="M78.658 106.008a1.166 1.166 0 1 0-1.65 1.648 1.166 1.166 0 0 0 1.65-1.648Zm-2.357-.707a2.165 2.165 0 0 1 3.64 1.032H82v1h-2.058c-.09.378-.281.737-.576 1.032a2.153 2.153 0 0 1-1.032.576v2.058h-1v-2.058a2.167 2.167 0 0 1-1.032-3.64Zm6.365 1.532a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0Zm2 2.166v2h-1v-2h1Zm-8.333 4.167a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0Zm6.333 0a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0Zm-.667.5h-2v-1h2v1Z"
				clipRule="evenodd"
			/>
			<path fill="#E5E9F6" fillOpacity={0.25} d="M94 106h21v6H94z" opacity={0.2} />
			<mask
				id="path-19-outside-1_8794_200494"
				width={104}
				height={67}
				x={62.826}
				y={20.826}
				fill="#000"
				maskUnits="userSpaceOnUse"
			>
				<path fill="#fff" d="M62.826 20.826h104v67h-104z" />
				<path d="M64.826 28.826a6 6 0 0 1 6-6h87.489a6 6 0 0 1 6 6v50.642a6 6 0 0 1-6 6H70.826a6 6 0 0 1-6-6V28.825Z" />
			</mask>
			<path
				fill="#1F1F21"
				d="M64.826 28.826a6 6 0 0 1 6-6h87.489a6 6 0 0 1 6 6v50.642a6 6 0 0 1-6 6H70.826a6 6 0 0 1-6-6V28.825Z"
			/>
			<g
				clipPath="url(#paint0_angular_8794_200494_clip_path)"
				data-figma-skip-parse="true"
				mask="url(#path-19-outside-1_8794_200494)"
			>
				<foreignObject
					width={2127.71}
					height={2127.71}
					x={-1063.86}
					y={-1063.86}
					transform="matrix(0 .03132 -.04974 0 114.571 54.147)"
				>
					<div
						style={{
							background:
								'conic-gradient(from 90deg,#d0ad13 0deg,#81b435 43.2deg,#0469fe 117deg,#bf63f3 203.4deg,#e2e3e4 266.4deg,#ffa900 334.8deg,#d0ad13 360deg)',
							height: '100%',
							width: '100%',
							opacity: 1,
						}}
					/>
				</foreignObject>
			</g>
			<path
				d="M70.826 22.826v2h87.489v-4H70.826v2Zm93.489 6h-2v50.642h4V28.825h-2Zm-6 56.642v-2H70.826v4h87.489v-2Zm-93.489-6h2V28.825h-4v50.642h2Zm6 6v-2a4 4 0 0 1-4-4h-4a8 8 0 0 0 8 8v-2Zm93.489-6h-2a4 4 0 0 1-4 4v4a8 8 0 0 0 8-8h-2Zm-6-56.642v2a4 4 0 0 1 4 4h4a8 8 0 0 0-8-8v2Zm-87.489 0v-2a8 8 0 0 0-8 8h4a4 4 0 0 1 4-4v-2Z"
				data-figma-gradient-fill='{"type":"GRADIENT_ANGULAR","stops":[{"color":{"r":0.50968009233474731,"g":0.70840001106262207,"b":0.21160000562667847,"a":1.0},"position":0.11999999731779099},{"color":{"r":0.016105264425277710,"g":0.41271612048149109,"b":0.99826967716217041,"a":1.0},"position":0.32499998807907104},{"color":{"r":0.74901962280273438,"g":0.38823530077934265,"b":0.95294117927551270,"a":1.0},"position":0.56499999761581421},{"color":{"r":0.88627451658248901,"g":0.89019608497619629,"b":0.89411765336990356,"a":1.0},"position":0.74000000953674316},{"color":{"r":1.0,"g":0.66274511814117432,"b":0.0,"a":1.0},"position":0.93000000715255737}],"stopsVar":[{"color":{"r":0.50968009233474731,"g":0.70840001106262207,"b":0.21160000562667847,"a":1.0},"position":0.11999999731779099},{"color":{"r":0.016105264425277710,"g":0.41271612048149109,"b":0.99826967716217041,"a":1.0},"position":0.32499998807907104},{"color":{"r":0.74901962280273438,"g":0.38823530077934265,"b":0.95294117927551270,"a":1.0},"position":0.56499999761581421},{"color":{"r":0.88627451658248901,"g":0.89019608497619629,"b":0.89411765336990356,"a":1.0},"position":0.74000000953674316},{"color":{"r":1.0,"g":0.66274511814117432,"b":0.0,"a":1.0},"position":0.93000000715255737}],"transform":{"m00":2.8904375994898146e-06,"m01":-99.489128112792969,"m02":164.31529235839844,"m10":62.641304016113281,"m11":5.0123285291192587e-06,"m12":22.826169967651367},"opacity":1.0,"blendMode":"NORMAL","visible":true}'
				mask="url(#path-19-outside-1_8794_200494)"
			/>
			<g
				clipPath="url(#paint1_angular_8794_200494_clip_path)"
				data-figma-skip-parse="true"
				mask="url(#path-19-outside-1_8794_200494)"
			>
				<foreignObject
					width={2127.71}
					height={2127.71}
					x={-1063.86}
					y={-1063.86}
					transform="matrix(0 .03132 -.04974 0 114.571 54.147)"
				>
					<div
						style={{
							background:
								'conic-gradient(from 90deg,#d0ad13 0deg,#81b435 43.2deg,#0469fe 117deg,#bf63f3 203.4deg,#e2e3e4 266.4deg,#ffa900 334.8deg,#d0ad13 360deg)',
							height: '100%',
							width: '100%',
							opacity: 1,
						}}
					/>
				</foreignObject>
			</g>
			<path
				d="M70.826 22.826v2h87.489v-4H70.826v2Zm93.489 6h-2v50.642h4V28.825h-2Zm-6 56.642v-2H70.826v4h87.489v-2Zm-93.489-6h2V28.825h-4v50.642h2Zm6 6v-2a4 4 0 0 1-4-4h-4a8 8 0 0 0 8 8v-2Zm93.489-6h-2a4 4 0 0 1-4 4v4a8 8 0 0 0 8-8h-2Zm-6-56.642v2a4 4 0 0 1 4 4h4a8 8 0 0 0-8-8v2Zm-87.489 0v-2a8 8 0 0 0-8 8h4a4 4 0 0 1 4-4v-2Z"
				data-figma-gradient-fill='{"type":"GRADIENT_ANGULAR","stops":[{"color":{"r":0.50968009233474731,"g":0.70840001106262207,"b":0.21160000562667847,"a":1.0},"position":0.11999999731779099},{"color":{"r":0.016105264425277710,"g":0.41271612048149109,"b":0.99826967716217041,"a":1.0},"position":0.32499998807907104},{"color":{"r":0.74901962280273438,"g":0.38823530077934265,"b":0.95294117927551270,"a":1.0},"position":0.56499999761581421},{"color":{"r":0.88627451658248901,"g":0.89019608497619629,"b":0.89411765336990356,"a":1.0},"position":0.74000000953674316},{"color":{"r":1.0,"g":0.66274511814117432,"b":0.0,"a":1.0},"position":0.93000000715255737}],"stopsVar":[{"color":{"r":0.50968009233474731,"g":0.70840001106262207,"b":0.21160000562667847,"a":1.0},"position":0.11999999731779099},{"color":{"r":0.016105264425277710,"g":0.41271612048149109,"b":0.99826967716217041,"a":1.0},"position":0.32499998807907104},{"color":{"r":0.74901962280273438,"g":0.38823530077934265,"b":0.95294117927551270,"a":1.0},"position":0.56499999761581421},{"color":{"r":0.88627451658248901,"g":0.89019608497619629,"b":0.89411765336990356,"a":1.0},"position":0.74000000953674316},{"color":{"r":1.0,"g":0.66274511814117432,"b":0.0,"a":1.0},"position":0.93000000715255737}],"transform":{"m00":2.8904375994898146e-06,"m01":-99.489128112792969,"m02":164.31529235839844,"m10":62.641304016113281,"m11":5.0123285291192587e-06,"m12":22.826169967651367},"opacity":1.0,"blendMode":"NORMAL","visible":true}'
				mask="url(#path-19-outside-1_8794_200494)"
			/>
			<rect width={16} height={16} x={73} y={32} fill="#4B4D51" rx={4} />
			<path
				fill="#A9ABAF"
				fillRule="evenodd"
				d="M80.313 34.995c.422-.254.95-.254 1.372 0l3.333 2c.402.24.647.675.647 1.143v3.723c0 .468-.245.902-.647 1.143l-3.333 2c-.423.254-.95.254-1.372 0l-3.334-2a1.334 1.334 0 0 1-.647-1.143v-3.723c0-.468.246-.902.647-1.143l3.334-2Zm.857.857a.334.334 0 0 0-.343 0l-3.333 2a.333.333 0 0 0-.162.286v3.723c0 .117.062.226.162.286l.732.44a2.833 2.833 0 1 1 5.545 0l.733-.44c.1-.06.161-.169.161-.286v-3.723a.333.333 0 0 0-.162-.286l-3.333-2ZM81 40.166a1.833 1.833 0 1 0 0 3.667 1.833 1.833 0 0 0 0-3.667Z"
				clipRule="evenodd"
			/>
			<path fill="#E5E9F6" fillOpacity={0.25} d="M93 37h32v6H93z" opacity={0.2} />
			<path
				fill="#CECFD2"
				d="M25 29a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H31a6 6 0 0 1-6-6V29Z"
			/>
			<path fill="#1F1F21" d="M35.7 34.222V42h7.8v-7.778h-7.8Z" />
			<path
				fill="#1F1F21"
				d="M39.6 30.609 35.05 28l-4.55 2.609v5.217l3.64 2.087v-5.246h5.46v-2.058Z"
			/>
			<g fill="#CECFD2" clipPath="url(#clip1_8794_200494)">
				<path d="M57.656 78.34c-.21.413-1.15.18-1.144-.28.013-.656.1-1.319.296-2.151.278-.938.535-1.122.67-1.763.273-1.083.461-2.965.503-3.424.01-.07.017-.13.043-.196.018-.067.03-.01.065-.073.005-.017.015-.023.011-.042 0 0-.014-.013-.02-.023l-.017-.005-.177-.047a29.555 29.555 0 0 0-1.957-.317c-1.262-.212-2.04-.339-2.448-.403-.958-.166-1.667-.384-2.346-.683-.371-.163-.237-1.003.17-1.038.74-.064 1.476-.047 2.438.102.372.064 1.195-.041 2.303.103.184.022.361.07.531.142.484.183 1.03.339 1.531.455l.186.05c.105.01.198.035.293.051.207.038.405.073.592.114.38.066.718.12 1.003.17-.17.703-.26 1.104-.26 1.104l-1.108 4.472c-.231.931-.343 1.38-.415 1.65-.213.828-.446 1.46-.745 2.04l.002-.008Z" />
				<path d="M36.445 51.09c.817-.892 1.532-.222.951.697-.784 1.344-1.5 2.805-2.028 4.804-.302 1.13-.441 1.85-.53 2.486a7.888 7.888 0 0 0-.074 1.994c.096 1.363.603 3.142 1.339 4.577.347.725.796 1.342 1.139 1.85.396.476.703.847.875 1.047.115.112.227.233.331.35.35.447 1.39 1.62 3.043 2.668.81.55 1.803.989 2.842 1.357 1.05.327 2.166.58 3.26.612.764.078 1.457.02 2.086-.001a30.696 30.696 0 0 0 1.661-.233 13.747 13.747 0 0 0 2.116-.616c2.188-.85 3.667-1.853 5.04-2.967.728-.626 1.398-.095.752.735-1.195 1.459-2.752 2.785-5.206 3.753-.933.346-2.947 1.324-6.038 1.263-.496-.033-1-.042-1.48-.17-2.093-.417-4.354-1.348-5.932-2.367a8.62 8.62 0 0 1-1.07-.729c-.304-.244-.6-.422-.806-.631-.43-.386-.686-.609-.686-.609s-.093-.088-.26-.241c-.154-.168-.376-.417-.649-.716-.552-.6-1.22-1.51-1.829-2.576-1.264-2.127-1.9-5.007-1.948-6.718-.097-2.573.286-3.798.446-4.532.599-2.233 1.563-3.808 2.655-5.087Z" />
			</g>
		</g>
		<defs>
			<clipPath id="paint0_angular_8794_200494_clip_path">
				<path
					d="M70.826 22.826v2h87.489v-4H70.826v2Zm93.489 6h-2v50.642h4V28.825h-2Zm-6 56.642v-2H70.826v4h87.489v-2Zm-93.489-6h2V28.825h-4v50.642h2Zm6 6v-2a4 4 0 0 1-4-4h-4a8 8 0 0 0 8 8v-2Zm93.489-6h-2a4 4 0 0 1-4 4v4a8 8 0 0 0 8-8h-2Zm-6-56.642v2a4 4 0 0 1 4 4h4a8 8 0 0 0-8-8v2Zm-87.489 0v-2a8 8 0 0 0-8 8h4a4 4 0 0 1 4-4v-2Z"
					mask="url(#path-19-outside-1_8794_200494)"
				/>
			</clipPath>
			<clipPath id="paint1_angular_8794_200494_clip_path">
				<path
					d="M70.826 22.826v2h87.489v-4H70.826v2Zm93.489 6h-2v50.642h4V28.825h-2Zm-6 56.642v-2H70.826v4h87.489v-2Zm-93.489-6h2V28.825h-4v50.642h2Zm6 6v-2a4 4 0 0 1-4-4h-4a8 8 0 0 0 8 8v-2Zm93.489-6h-2a4 4 0 0 1-4 4v4a8 8 0 0 0 8-8h-2Zm-6-56.642v2a4 4 0 0 1 4 4h4a8 8 0 0 0-8-8v2Zm-87.489 0v-2a8 8 0 0 0-8 8h4a4 4 0 0 1 4-4v-2Z"
					mask="url(#path-19-outside-1_8794_200494)"
				/>
			</clipPath>
			<clipPath id="clip0_8794_200494">
				<path fill="#fff" d="M0 8a8 8 0 0 1 8-8h319a8 8 0 0 1 8 8v120H0V8Z" />
			</clipPath>
			<clipPath id="clip1_8794_200494">
				<path fill="#fff" d="m35.445 50-5.69 21.236 27.995 7.501 5.69-21.236z" />
			</clipPath>
		</defs>
	</svg>
);
